import router from '../../router'
import NavigationBar from '../../components/navigation-bar/NavigationBar'
import TabBar from '../../components/tab-bar/TabBar'
import {SortedTable, SortLink} from 'vue-sorted-table'
import {Location, LocationDropdown, LocationService} from '../../services/location.service'
import {NotificationService, SMS} from '../../services/notification.service'
import {Booking, BookingOption, BookingService} from '../../services/booking.service'
import {EntityService, EntityUtilityService} from '../../services/entity.service'
import InputDropdown from '../../components/input-dropdown/InputDropdown'
import InputDropdownFilter from '../../components/input-dropdown-filter/InputDropdownFilter'
import InputDatePicker from '../../components/input-date-picker/InputDatePicker'
import InputCheckbox from '../../components/input-checkbox/InputCheckbox'
import InputText from '../../components/input-text/InputText'
import InputButton from '../../components/input-button/InputButton'
import InputFileSelector from '../../components/input-file-selector/InputFileSelector'
import Loader from '../../components/loader/Loader'
import BookingOptionsContainer from '../../components/booking-options-container/BookingOptionContainer'
import TimeslotContainer from '../../components/timeslot-container/TimeslotContainer'
import moment from 'moment'
import {Customer, CustomerDropdown, CustomerService} from '../../services/customer.service'
import {Constants} from '../../constants'
import {KeycloakService} from '../../services/keycloak.service'
import {SelectedTimeSlot, TimeSlotUtil} from '../../utils/timeslot.util'
import {ScreenLoader} from '../../utils/loading.util'
import {Group, GroupDropdown} from '../../services/group.service'
import {Confirm} from '../../services/api.service'
import Card from '../../components/card/Card'
import {AccountService} from '@/services/account.service'
import {BookingFile, FileService} from "@/services/file.service";
import BookingSummary from '../../components/summary/BookingSummary'
import Vue from "vue";
export default {
    name: 'Booking',
    components: {
        NavigationBar,
        TabBar,
        BookingOptionsContainer,
        TimeslotContainer,
        InputDropdown,
        InputDropdownFilter,
        InputDatePicker,
        InputCheckbox,
        InputText,
        InputButton,
        InputFileSelector,
        SortedTable,
        SortLink,
        Loader,
        Card,
        BookingSummary,
    },

    data() {
        return {
            isAllowedToSetTimeSlotLength: true,
            booking: new Booking(),
            bookingOptions: [],
            dropdownLocations: [],
            locations: [],
            customers: [],
            dropdownCustomers: [],
            dropdownGroups: [],
            entities: [],
            hasEntityError: false,
            timeSlots: [],
            activeTimeSlots: [],
            selectedTimeSlot: new SelectedTimeSlot(),
            selectedGroup: new Group(),
            hasSpotError: false,
            showSummary: false,
            screenLoader: new ScreenLoader(),
            confirm: new Confirm(),
            showCard: false,
            showSmsCard: false,
            useDefaultSpots: false,
            sms: new SMS(),
            isAllowedToSms: false,
            enteredEmail: "",
            pickedFiles: [],
            bookingFiles: [],
            unavailableSpots: [],
            deleteSeries: false
        }
    },

    async mounted() {
        this.booking.mount(this.$route.params, this.$route.query)
        this.showSummary = this.booking?.id != undefined
        this.screenLoader.start(['locations'])
        await this.getData()

    },

    watch: {
        'booking.licensePlate'(value) {
            this.booking.licensePlate = value ? value.toUpperCase() : value
        },

        'booking.trailerPlate'(value) {
          this.booking.trailerPlate = value ? value.toUpperCase() : value
        }
    },

    computed: {
        isBookingAgent() {
            return KeycloakService.isBookingAgent()
        },

        showBooking() {
            const hasCustomer = this.booking.customer && this.booking.customer.id
            return  this.booking.location.id &&
                    !this.screenLoader.isLoading &&
                    !this.screenLoader.hasError &&
                    !this.showSummary &&
                    hasCustomer
        },

        showDeclineButton() {
            return this.booking.status && this.booking.status.id == '1' && !this.isBookingAgent
        },

        isLpMandatory () {
            return this.booking?.location?.useTruckLicensePlateAsBookingOption ?? false
        },

        isTpMandatory () {
            return this.booking?.location?.useTrailerLicensePlateAsBookingOption ?? false
        },

        recurringLabel () {
            if (this.booking.recurringIntervalWeeks == undefined || this.booking.recurringIntervalWeeks == 0) {
                return 'recurring every amount of weeks'
            }
            return `Recurring every ${this.booking.recurringIntervalWeeks} week(s)`
        }
    },

    methods: {
        reload() {
            if (this.showSummary) {
                this.screenLoader.stop()
            } else {
                this.getData()
            }
        },

        async getData() {
            if(this.booking.location.id){
                await this.getCustomers()
                    .catch((error) =>{
                        this.screenLoader.stopWithError(error, ['locations'])
                    })

                this.getMetaData()
            } else {
                /*
                if true, and an error is thrown, it happened during get booking
                We need to discern this case because an error thrown during
                getbooking requires different handling
                 */
                let bookingError = false
                await this.getCustomers()
                    .then(LocationService.getLocations)
                    .then(this.handleLocationsResponse)
                    .then((result) => {
                        bookingError = true
                        return this.getBooking()
                    })
                    .catch((error) => {
                        if (bookingError){
                            this.screenLoader.stopWithAlert(this.$store, error, ['locations'])
                        } else {
                            this.screenLoader.stopWithError(error, ['locations'])
                        }
                    })

            }
        },

        doClear(reference) {
            this.booking[reference] = ''
        },

        doClearBookingOption(referenceId) {
            for (const bookingOption of this.bookingOptions) {
                if (bookingOption.id == referenceId) {
                    bookingOption.value = ''
                }
            }
        },

        postSMS: async function() {
                await NotificationService.sendSMS(this.sms)
                    .then((response) => {
                        this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code:response.status, message: 'SMS sent'})
                    })
                    .catch((error) => {
                        this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code:"400", message: "SMS could not be delivered"})
                    })
            this.showSmsCard = false
        },

        doValidate() {
            let bookingHasErrors = false
            let bookingOptionsHasErrors = false

            this.hasSpotError = !this.isBookingAgent && !this.booking.isRecurringBooking
            //Check if atleast one spot is selected
            for (const spot of this.selectedGroup.getSortedSpots()) {
                if (spot.selected) {
                    this.hasSpotError = false
                }
            }
            if (!this.booking.isRecurringBooking) { // do not check booking option fields when making a recurring bookings
                // check each component for errors
                for (const ref in this.$refs) {
                    const component = this.$refs[ref] && this.$refs[ref][0] ? this.$refs[ref][0] : this.$refs[ref]
                    if (component != undefined && !Array.isArray(component)) {
                        if (component.checkForError()) {
                            bookingHasErrors = true
                        }
                    }
                }
            }

            // dont check this if the booking summary is shown or when making a recurring booking
            if (!this.showSummary && !this.booking.isRecurringBooking ) {
                bookingOptionsHasErrors = this.$refs.BookingOptionsContainer.checkForError()
            }
            this.booking.options = this.bookingOptions
            this.updateBookingEntity()

            const hasTimeSlotError = this.isAllowedToSetTimeSlotLength ? false : this.getRequiredTimeSlotLength() != this.getSelectedTimeSlotLength()

            const hasCustomerError = !this.booking.customer.id
            this.hasEntityError = this.selectedTimeSlot.startIndex == undefined || this.booking.entity.startDate == this.booking.entity.endDate || hasTimeSlotError
            if (bookingOptionsHasErrors || bookingHasErrors || this.hasEntityError || hasCustomerError || (this.hasSpotError && !this.useDefaultSpots)) {
                return
            }

            this.showSummary = true
            window.scrollTo(0,0)
        },

        updateBookingEntity() {
            if (this.selectedTimeSlot.startIndex != undefined) {
                const timeSlotStart = this.activeTimeSlots[this.selectedTimeSlot.entityIndex][this.selectedTimeSlot.startIndex]
                const startDate = moment(this.booking.arrivalDate).set({ hours: timeSlotStart.hours, minutes: timeSlotStart.minutes, seconds: 0, milliseconds: 0 })
                const endDate = moment(startDate).add(this.getSelectedTimeSlotLength(), 'minutes')
                this.booking.entity.id = this.entities[this.selectedTimeSlot.entityIndex].id
                this.booking.entity.startDate = startDate.toDate()
                this.booking.entity.endDate = endDate.toDate()
                this.booking.entity.name = this.entities[this.selectedTimeSlot.entityIndex].name
            }
        },

        doCancel() {
            if (this.$router.referer.name != undefined) {
                router.go(-1)
            } else {
                router.go(-1)
            }
        },

        doDecline(message) {
            this.showCard = false
            this.doConfirm({ id: '3' }, message?.message, message?.deleteSeries)
        },

        doConfirm(status, userMessage = undefined, deleteSeries=false) {
                const booking = JSON.parse(JSON.stringify(this.booking))
                booking.status = status

                if (booking.status == undefined || booking.status.id != 3 || this.useDefaultSpots) {
                    delete booking.status
                }

                booking.spots = this.selectedGroup.spots.filter(spot => spot.selected)
                if (booking.spots.length == 0) {
                    delete booking.spots
                }

                if (booking.isRecurringBooking) {
                    booking.recurringEndDate = moment(booking.recurringEndDate).endOf('day')
                }

                // parse undefined bools
                for (let option of booking.options) {
                    if (option.value == undefined && option.type == "Boolean") {
                        option.value = false
                    }
                }

                if (this.booking.id == undefined) {
                    this.createBooking(booking)
                } else {
                    this.updateBooking(booking, userMessage, deleteSeries)
                }
        },


        createBooking: async function(booking) {
            this.screenLoader.start()
            BookingService.createBooking(booking)
                .then((response) => {
                    const bookingId = response?.data?.bookingId ?? undefined

                    for (const file of this.pickedFiles) {
                        FileService.sendBookingFile(file, this.booking.customer.id, bookingId)
                            .catch((error) => {
                                this.screenLoader.stop()
                                this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {
                                    code: error.errorCode, message:
                                        "An error has occured during uploading of the files"
                                })
                            })
                    }

                    return response
                })
                .then(this.handleMutateBookingResponse)
                .catch((error) =>{
                    this.screenLoader.stop()
                    this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.errorCode, message:
                            "An error has occured at" + error.message.errorAtEntry})
                })
        },

        updateBooking: async function(booking, usermessage = undefined, deleteSeries = false) {

            this.screenLoader.start()
            await BookingService.updateBooking(booking, usermessage, deleteSeries)
                .then(this.handleMutateBookingResponse)
                .catch((error) =>{
                    this.screenLoader.stop()
                    this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.errorCode, message:
                            "An error has occured at : " + error.message.errorAtEntry})
                })
            try {
                for (const file of this.pickedFiles) {
                    await FileService.sendBookingFile(file, this.booking.customer.id, this.booking.id)
                }
                for (const file of this.bookingFiles) {
                    if (file.removed) {
                        await FileService.removeBookingFile(file.name, this.booking.customer.id, this.booking.id)
                    }
                }
            }catch(error) {
                this.screenLoader.stop()
                await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {
                    code: error.errorCode, message:
                        "An error has occured during uploading of the files"
                })
            }
        },

        handleMutateBookingResponse(response) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: 'The visit has been succesfully created' })
            const date = moment(this.booking.arrivalDate).toISOString()
            //TODO does this need to stay, or is -1 enough?
            //const target = `/visits?locationid=${this.booking.location.id}&date=${date}`
            //router.push(target)
            router.go(-1)
        },

        toggleIsRecurringBooking() {
            this.booking.isRecurringBooking = !this.booking.isRecurringBooking
            if (this.booking.isRecurringBooking) {
                this.bookingOptions = this.bookingOptions.map((option) => {
                    if (option.isGenerated) option.value = null
                    return option
                })
            }
        },

        toggleBookingOption(bookingOption) {
            bookingOption.value = !bookingOption.value
        },

        toggleSpot(index) {
            const sortedSpots = this.selectedGroup.getSortedSpots()
            sortedSpots[index].selected = !sortedSpots[index].selected
            this.hasSpotError = false
        },

        getBooking: async function() {
            if (this.booking.location.id != undefined) {

                this.getMetaData()
                return
            }
            //booking does not yet exist
            if (this.booking.id == undefined) {
                this.screenLoader.stop()
                return
            }


            this.screenLoader.start(['locations'])
            //booking exists
            try {
                await BookingService.getBooking(this.booking.id)
                    .then(this.handleBookingResponse);
                // await this.handleBookingResponse(booking);
                const files = await FileService.getBookingFiles(this.booking.customer.id, this.booking.id);
                this.handleBookingFilesResponse(files)
            } catch (error) {
                this.screenLoader.stopWithAlert(this.$store, error, ['locations'])
                router.go(-1)
            }
        },

        filterCustomersBasedOnLocation(locationId, customers) {
            return customers.filter(customer => {
                if (locationId == undefined) {
                    return true
                } else {
                    if (customer.locations.map(l => l.id).includes(locationId)) {
                        return true
                    }
                }
                return false
            })
        },

        getCustomers: async function() {
            if (!KeycloakService.isBookingAgent()) {
                const locations = await LocationService.getLocations()
                this.isAllowedToSms = true
                await CustomerService.getCustomers(true).then((customers) => {
                    this.customers = customers.map(o => new Customer(o)).filter(customer => {
                        const locationIds = locations.map(l => l.id)
                        const customerLocations = customer.locations.map(l => l.id)
                        const locationHasCustomer = locationIds.filter(location => customerLocations.includes(location)).length > 0
                        return locationHasCustomer
                    })
                    this.dropdownCustomers = this.filterCustomersBasedOnLocation(this.booking.location.id, this.customers).filter(customer => customer.active).map(customer => new CustomerDropdown(customer))
                    if (this.dropdownCustomers != undefined) {
                        this.dropdownCustomers = _.sortBy(this.dropdownCustomers, 'value')
                    }
                })

            } else {
                let account = await AccountService.getLoggedInAccount()
                let customers = account.customers
                for (let i = 0; i < customers.length; i++) {
                    customers[i].locations = []
                }
                const databaseCustomers = await CustomerService.getCustomers(true)

                this.customers = databaseCustomers.filter((customer) => {
                    return customer.active && customers.map(c => c.id).includes(customer.id)
                }).map(customer => new Customer(customer))

                this.isAllowedToSetTimeSlotLength = false
                this.dropdownCustomers = this.customers.map(o => new CustomerDropdown(o))
                if (this.dropdownCustomers != undefined) {
                    this.dropdownCustomers = _.sortBy(this.dropdownCustomers, 'value')
                }
            }
        },

        getMetaData: async function() {
            const customerId = this.booking.customer ? this.booking.customer.id : undefined

            if (this.booking.location.id == undefined || (!this.isBookingAgent && customerId == undefined)) {
                    this.screenLoader.stop()
                return
            }

            this.screenLoader.start()

            try {
                const [location, entities] = await Promise.all([
                    LocationService.getLocation(this.booking.location.id),
                    !this.isBookingAgent ? EntityService.getEntities(this.booking.location.id, this.booking.arrivalDate, undefined, customerId) : EntityService.getEntities(this.booking.location.id, this.booking.arrivalDate, undefined)
                ])

                if (this.isBookingAgent && customerId != undefined && this.booking.location.id != undefined) {
                    let customer = await CustomerService.getCustomer(customerId)
                    let filteredEntities = []
                    try {
                        let customerEntities = customer.locations.find(l=> l.id == location.id).entities.map(e => e.id)
                        filteredEntities = entities.filter(e => customerEntities.includes(e.id))
                    } catch (error) {
                        console.log("No entities found")
                    }

                    this.handleMetaDataResponse(location, filteredEntities)
                } else {
                    this.handleMetaDataResponse(location, entities)
                }
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleBookingResponse(booking) {
            this.booking = new Booking(booking)
            this.booking.location = this.locations.filter(o => booking.location.id == o.id)[0]
            this.booking.customer = booking.customer ? this.customers.filter(o => booking.customer.id == o.id)[0] : undefined

            //check whether to show the summary
            this.showSummary = this.booking.status.id == "1" ? false : true // if the booking is requested then do not show the summary

            this.checkSpotOverlap(this.booking.getSelectedGroup(), this.booking.entity.startDate, this.booking.entity.endDate)

            this.screenLoader.stop()
            this.updateArrivalDate(new Date(booking.entity.startDate))
        },

        handleBookingFilesResponse: function(files) {
            files.data.forEach((file) => {
                this.bookingFiles.push(new BookingFile(file.Key))
            })
        },

        removeFile: function (removedFile) {
            this.bookingFiles.forEach((file) => {
                if (file.name === removedFile.name) {
                    file.removed = true
                }
            });
        },

        restoreFile: function(restoredFile) {
            this.bookingFiles.forEach((file) => {
                if (file.name === restoredFile.name) {
                    file.removed = false
                }
            });
        },

        addFile: function(files) {
            Array.from(files).forEach((file) => {this.pickedFiles.push(file)})

        },
        //called from child component
        downloadFile: async function (file) {
            await FileService.downloadFile(file.name, this.booking.customer.id, this.booking.id)
        },

        removePicked: function (removedFile) {
            this.pickedFiles = this.pickedFiles.filter(file => file.name !== removedFile.name);
        },

        handleLocationsResponse(locations) {
            this.locations = locations.map(o => new Location(o))
            this.dropdownLocations = locations.map(o => new LocationDropdown(o))
            //if editing a booking, find and set location
            if (this.booking.location.id != undefined) {
                this.booking.location = this.locations.filter(o => this.booking.location.id == o.id)[0]
                this.checkSpotOverlap(this.booking.location.groups[0], this.booking.entity.startDate, this.booking.entity.endDate)
            }
        },

        handleCustomersResponse(customers) {
            this.customers = customers.map(o => new Customer(o))
            this.dropdownCustomers = customers.map(o => new CustomerDropdown(o))
            if (this.dropdownCustomers != undefined) {
                this.dropdownCustomers = _.sortBy(this.dropdownCustomers, 'value')
            }
        },

        handleMetaDataResponse(location, entities) {
            //this.updateBookingEntity()
            this.selectedTimeSlot = new SelectedTimeSlot()
            this.activeTimeSlots = []
            this.timeSlots = []
            this.dropdownGroups = location.groups.map(group => new GroupDropdown(group))
            let entityArr = entities.filter(entity => entity.active)
            this.entities = this.sortEntities(entityArr)

            for (const entity of this.entities) {
                entity.bookings = entity.bookings.filter(booking => booking.id != this.booking.id)
            }

            //Overwrite user bookingOptions when the user bookingOptions are empty
            //This is used when opening an already created booking
            if (this.bookingOptions.length == 0) {
                this.bookingOptions = this.booking.options
            }

            this.booking.location = new Location(location)
            this.selectedGroup = this.booking.getSelectedGroup()
            this.selectedGroup.setSelectedSpots(this.booking.spots)

            const startTime = TimeSlotUtil.getTimeSlotTime(location.timeSlotStartTime)
            const endTime = TimeSlotUtil.getTimeSlotTime(location.timeSlotEndTime)
            const bookedEntityIndex = this.getBookedEntityIndex()

            this.timeSlots = TimeSlotUtil.createTimeSlots(startTime, endTime, location.timeSlotLengthInMinutes, false)
            this.activeTimeSlots = TimeSlotUtil.createActiveTimeSlots(this.booking.arrivalDate, startTime, endTime, this.entities)

            if (bookedEntityIndex != -1 && this.entities[bookedEntityIndex] != undefined) {
                this.selectedTimeSlot = TimeSlotUtil.createSelectedTimeSlot(bookedEntityIndex, this.entities[bookedEntityIndex].bookings, this.booking.entity, this.activeTimeSlots[bookedEntityIndex], this.booking.arrivalDate)
            }

            this.updateTimeSlots(true)
            if (this.selectedTimeSlot.startIndex == this.selectedTimeSlot.endIndex) {
                this.selectedTimeSlot.endIndex = undefined
            }

            this.updateBookingOptions(true)
            this.screenLoader.stop()
            if (this.booking.status && this.booking.status.name == Constants.STATUS_ACCEPTED && this.$refs.BookingOptionsContainer) {
                this.doValidate()
            }
        },

        sortEntities (entities) {
            return entities.sort((a, b) => {
                if ( a.name < b.name ){
                    return -1;
                }
                if ( a.name > b.name ){
                    return 1;
                }
                return 0;
            })
        },

        getBookedEntityIndex() {
            for (var i = 0; i < this.entities.length; i++) {
                if (this.entities[i].id == this.booking.entity.id) {
                    return i
                }
            }
            return -1
        },

        updateCustomer(id) {
            this.booking.customer = this.customers.filter(customer => customer.id == id)[0]
            if (KeycloakService.isBookingAgent()) {
                this.isAllowedToSetTimeSlotLength = this.booking.customer.allowSetTimeSlotLength
            }
            this.getMetaData()
        },

        updateLocation: async function(id) {
            this.booking.location = this.locations.filter(location => location.id == id)[0]
            this.dropdownCustomers = this.filterCustomersBasedOnLocation(this.booking.location.id, this.customers.filter(c => c.active)).map(customer => new CustomerDropdown(customer))
            this.booking.location = await LocationService.getLocation(this.booking.location.id)
            this.getMetaData()
        },

        updateGroup(id) {
            this.selectedGroup = this.booking.location.groups.filter(group => group.id == id)[0]
            this.hasSpotError = false
            this.checkSpotOverlap(this.selectedGroup, this.booking.entity.startDate, this.booking.entity.endDate)

        },

        updateArrivalDate(date) {
            if (this.booking.arrivalDate != date) {
                this.booking.arrivalDate = date
                this.getMetaData()
            }
        },

        updateRecurringEndDate(date) {
            this.booking.recurringEndDate = date
        },

        updateBookingOptions(entityChanged = true) {
            if (this.selectedTimeSlot.entityIndex == undefined) {
                this.bookingOptions = []
                return
            }
            const rawEntityBookingOptions = this.entities[this.selectedTimeSlot.entityIndex].bookingOptions
            let options = []
            // here we have to differentiate between new and existing bookings since new bookings don't have any options yet.
            if (this.booking.id == undefined && entityChanged ) {
                options = rawEntityBookingOptions.map((option) => {
                    const bookingOption = new BookingOption(option)
                    if (bookingOption.isGenerated && !this.booking.isRecurringBooking) {
                        // check if generated value already exists
                        if (this.booking.options.find(bOption => bOption.id === bookingOption.id)) {
                            bookingOption.value = this.booking.options.find(bOption => bOption.id === bookingOption.id).value;
                            // else get a generated one
                        } else {
                            BookingService.getBookingOptionById(bookingOption.id).then(result =>
                                bookingOption.value = result.generated
                            )
                        }
                    }
                    if (bookingOption.type == 'Date' && bookingOption.value == undefined) {
                        bookingOption.value = new Date()
                    }
                    return bookingOption
                })
            } else {
                options = this.bookingOptions?.map((option) => {
                    const bookingOption = new BookingOption(rawEntityBookingOptions.find(b => b.id == option.id))

                    if (bookingOption.isGenerated && !this.booking.isRecurringBooking) {
                        // check if generated value already exists
                        if (this.booking.options.find(bOption => bOption.id === bookingOption.id)) {
                            bookingOption.value = this.booking.options.find(bOption => bOption.id === bookingOption.id).value;
                            // else get a generated one
                        } else {
                            BookingService.getBookingOptionById(bookingOption.id).then(result =>
                                bookingOption.value = result.generated
                            )
                        }
                    }

                    bookingOption.value = option.value
                    if (bookingOption.type == 'Date' && bookingOption.value == undefined) {
                        bookingOption.value = new Date()
                    }
                    return bookingOption
                })
            }
            const dateOptions = options.filter(opt => opt.type === 'Date')
            const otherOptions = options.filter(opt => opt.type !== 'Date')

            this.bookingOptions = this.filterOptionsArray([...otherOptions, ...dateOptions])
        },

        getSelectedTimeSlotLength() {
            if (this.selectedTimeSlot.entityIndex == undefined) {
                return 0
            }
            const entity = this.entities[this.selectedTimeSlot.entityIndex]
            return this.selectedTimeSlot.getTimeSlotCount() * entity.timeSlotLengthInMinutes
        },

        getRequiredTimeSlotLength() {
            if (this.selectedTimeSlot.entityIndex == undefined) {
                return 0
            }
            const entity = this.entities[this.selectedTimeSlot.entityIndex]
            const minutes = BookingOption.calculateRequiredMinimalTimeSlotLength(this.bookingOptions)
            const residual = minutes % entity.timeSlotLengthInMinutes
            const minutesInTimeSlotLength = minutes + (residual != 0 ? (entity.timeSlotLengthInMinutes - residual) : 0)
            return minutesInTimeSlotLength > 0 ? minutesInTimeSlotLength : entity.timeSlotLengthInMinutes
        },

        getRequiredTimeSlotEndIndex() {
            const timeSlotIndex = this.selectedTimeSlot.startIndex
            const entity = this.entities[this.selectedTimeSlot.entityIndex]
            const extraTimeSlotCountNeeded = this.getRequiredTimeSlotLength() / entity.timeSlotLengthInMinutes - 1
            let i = 0
            for (; i < extraTimeSlotCountNeeded; i++) {
                const endIndex = timeSlotIndex + i + 1
                if (this.isTimeSlotBooked(this.selectedTimeSlot.entityIndex, endIndex)) {
                    break;
                }
            }
            return timeSlotIndex + i
        },

        /**
         * Function that is called when clicking on a timeslot
         * @param entityIndex
         * @param timeSlotIndex
         */
        selectTimeSlot(entityIndex, timeSlotIndex) {
            this.hasEntityError = false
            if (this.isTimeSlotBooked(entityIndex, timeSlotIndex) ||
                this.isTimeSlotRangeBooked(entityIndex, timeSlotIndex)) {
                return
            }

            this.updateTimeSlots(false)

            if (timeSlotIndex == this.selectedTimeSlot.startIndex && this.selectedTimeSlot.entityIndex == entityIndex) {
                this.selectedTimeSlot.endIndex = undefined
                this.updateTimeSlots(true)
                return
            }

            const changedEntity = this.selectedTimeSlot.entityIndex != entityIndex
            if (changedEntity || this.selectedTimeSlot.endIndex) {
                this.selectedTimeSlot.startIndex = undefined
                this.selectedTimeSlot.endIndex = undefined
            }

            this.selectedTimeSlot.entityIndex = entityIndex

            if (this.selectedTimeSlot.startIndex == undefined) {
                this.selectedTimeSlot.startIndex = timeSlotIndex
                //Also update endIndex if user is not allowed to freely change time slot length
                if (!this.isAllowedToSetTimeSlotLength) {
                    this.selectedTimeSlot.endIndex = this.getRequiredTimeSlotEndIndex()
                }
            } else if (this.selectedTimeSlot.endIndex == undefined) {
                this.selectedTimeSlot.endIndex = timeSlotIndex
            }
            this.updateTimeSlots(true)

            // get the spot statuses
            this.checkSpotOverlap(this.selectedGroup)

            this.updateBookingOptions(changedEntity)
        },

        updateTimeSlots(active) {
            const startIndex = this.selectedTimeSlot.startIndex
            const endIndex = this.selectedTimeSlot.endIndex == undefined ? startIndex : this.selectedTimeSlot.endIndex

            if (endIndex < startIndex) {
                this.selectedTimeSlot.startIndex = endIndex
                this.selectedTimeSlot.endIndex = startIndex
                this.updateTimeSlots(true)
            } else {
                for (var i = startIndex; i <= endIndex; i++) {
                    const activeTimeSlot = this.activeTimeSlots[this.selectedTimeSlot.entityIndex][i]
                    const isTimeSlotBooked = this.isTimeSlotBooked(this.selectedTimeSlot.entityIndex, i) && this.booking.id == undefined
                    if (isTimeSlotBooked) {
                        this.selectedTimeSlot.endIndex = i - 1
                        return
                    }
                    activeTimeSlot.isActive = active
                }
            }
        },

        isTimeSlotActive(entityIndex, timeSlotIndex) {
            return this.activeTimeSlots[entityIndex][timeSlotIndex].isActive
        },

        isTimeSlotBooked(entityIndex, timeSlotIndex) {
            const entity = this.entities[entityIndex]
            var entityStartTime = TimeSlotUtil.getTimeSlotTime(entity.timeSlotStartTime)
            var entityEndTime = TimeSlotUtil.getTimeSlotTime(entity.timeSlotEndTime)
            entityStartTime = moment(this.booking.arrivalDate).set({ hours: entityStartTime.hours(), minutes: entityStartTime.minutes(), seconds: 0, milliseconds: 0 })
            entityEndTime = moment(this.booking.arrivalDate).set({ hours: entityEndTime.hours(), minutes: entityEndTime.minutes(), seconds: 0, milliseconds: 0 })

            const timeSlot = this.activeTimeSlots[entityIndex][timeSlotIndex]
            const timeSlotStartTime = moment(this.booking.arrivalDate).set({ hours: timeSlot.hours, minutes: timeSlot.minutes, seconds: 0, milliseconds: 0 })
            const timeSlotEndTime = moment(timeSlotStartTime).add(entity.timeSlotLengthInMinutes, 'minutes')
            // Timezone correction
            let locationOffset = moment().tz(this.booking.location.timezoneName).utcOffset() // get the utc offset for the location
            let correctedMoment = moment().add(locationOffset - moment().utcOffset(), 'm')

            const isFutureTimeSlot = correctedMoment.isBefore(timeSlotStartTime) || correctedMoment.isBetween(timeSlotStartTime, timeSlotEndTime)
            const isBetweenOpeningHours = timeSlot.isClosed
            const isAbleToBookInBookingWindow = EntityUtilityService.validateBookingWindow(timeSlotStartTime, correctedMoment, entity)

            return TimeSlotUtil.isTimeSlotBooked(entity.bookings, timeSlot, this.booking.arrivalDate) || !isAbleToBookInBookingWindow || !isFutureTimeSlot || !isBetweenOpeningHours
        },

        isTimeSlotRangeBooked(entityIndex, timeSlotIndex) {
            let startTimeSlotIndex = this.selectedTimeSlot.startIndex || timeSlotIndex
            let endTimeSlotIndex = this.selectedTimeSlot.endIndex || timeSlotIndex

            if (startTimeSlotIndex > endTimeSlotIndex) {
                startTimeSlotIndex = endTimeSlotIndex
                endTimeSlotIndex = this.selectedTimeSlot.startIndex
            }
            if (endTimeSlotIndex >= this.activeTimeSlots[entityIndex].length) {
                endTimeSlotIndex = this.activeTimeSlots[entityIndex].length - 1
                if (startTimeSlotIndex > endTimeSlotIndex) {
                    startTimeSlotIndex = endTimeSlotIndex
                }
            }

            for (var i = startTimeSlotIndex; i < endTimeSlotIndex; i++) {
                const isTimeSlotBooked = this.isTimeSlotBooked(entityIndex, i)
                const hasSameEntityIndex = entityIndex == this.selectedTimeSlot.entityIndex
                if (isTimeSlotBooked && hasSameEntityIndex) {
                    return true
                }
            }
            return false
        },

        checkSpotOverlap: async function(group, startDate, endDate) {
            //update location information to have the correct timezone offset
            let location = await LocationService.getLocation(this.booking.location.id)
            let timezoneName = location.timezoneName
            if (this.selectedTimeSlot.startIndex != undefined && startDate == undefined && endDate == undefined) {
                const timeSlotStart = this.activeTimeSlots[this.selectedTimeSlot.entityIndex][this.selectedTimeSlot.startIndex]

                let startDate = moment(this.booking.arrivalDate).set({
                    hours: timeSlotStart.hours,
                    minutes: timeSlotStart.minutes,
                    seconds: 0,
                    milliseconds: 0
                })
                //correct for timezone
                let locationOffset = moment().tz(timezoneName).utcOffset() // get the utc offset for the location
                let correctedStartMoment = startDate.subtract(locationOffset - moment().utcOffset(), 'm')
                let endDate = moment(correctedStartMoment).add(this.getSelectedTimeSlotLength(), 'minutes')

                this.booking.entity.id = this.entities[this.selectedTimeSlot.entityIndex].id
                startDate = correctedStartMoment.toISOString()
                endDate = endDate.toISOString()
                let response = await BookingService.checkSpotOverlap(group.id, startDate, endDate)
                this.unavailableSpots = response.data.map(o => o.spotId)
            } else {
                //correct for timezone
                let locationOffset = moment().tz(timezoneName).utcOffset() // get the utc offset for the location
                let correctedStartMoment = moment(startDate).subtract(locationOffset - moment().utcOffset(), 'm')
                let correctedEndMoment = moment(endDate).subtract(locationOffset - moment().utcOffset(), 'm')
                let correctedStartDate = correctedStartMoment.toISOString()
                let correctedEndDate = correctedEndMoment.toISOString()

                let response = await BookingService.checkSpotOverlap(group.id, correctedStartDate, correctedEndDate)
                this.unavailableSpots = response.data.map(o => o.spotId)
            }
        },

        selectedTab() {
            return this.showSummary ? 'summary' : this.booking.id != undefined ? 'edit visit' : 'new visit'
        },

        toggleCard() {
            this.showCard = !this.showCard
        },
        toggleSmsCard() {
            this.showSmsCard = !this.showSmsCard
        },

        toggleUseDefaultSpots() {
            this.useDefaultSpots = !this.useDefaultSpots
        },

        doClearUserEmail() {
            this.enteredEmail = ""
        },

        addCoupledUser() {
            this.booking.emailAddresses.push(this.enteredEmail)
            this.enteredEmail = ""
        },

        removeCoupledUser(email) {
            this.booking.emailAddresses = this.booking.emailAddresses.filter(e => e != email)
        },

        filterOptionsArray(data) {
            const result = []

            data.forEach((obj) => {
                if (result.find((option) => { return option.id === obj.id})) {
                    const valueExists = result.find((option) => { return (option.id === obj.id && option.value == obj.value)})
                    if (valueExists == undefined) {
                        result.push(obj)
                    }
                } else {
                    result.push(obj)
                }
            })

            return result
        }
    }
}
